module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedUltraBold.94d3e8e.woff";